import { numToAlpMonth, toExactSubstr } from '../../utils/utilityFunctions';
import data from './data-ts';
import { Chart as ChartJS, ChartData, ChartOptions, registerables } from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { monthwiseCommitmentAmountType } from '../../redux-store/types/api-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { monthwiseCommitmentAmount } from '../../redux-store/actions/application';
import {
  Card,
  CardMedia,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Skeleton,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { RootStateType } from '../../redux-store/reducers';
import _ from 'lodash';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { currencyType, USER_ROLES } from '../../utils/constant';

ChartJS.register(...registerables);

export const monthWiseCommit: monthwiseCommitmentAmountType = {
  data: [
    {
      month: '',
      completed: 0,
      contributionAmount: 0,
      commitmentAmount: 0,
    },
  ],
  year: '',
};

export default function CommitmentAndContribution(): JSX.Element {
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [commitAmtData, SetCommitAmtData] = useState(monthWiseCommit);
  const CommitmentAndContributionData = useSelector(
    (store: RootStateType) => store.commitmentAndContributionData
  );
  const [selectedCurrency, setSelectedCurrency] = useState<'inr' | 'usd'>('usd');
  const filterData = CommitmentAndContributionData.data.filter((a) => {
    return a.completed;
  });

  useEffect(() => {
    let componentIsAlive = true;
    (async function () {
      try {
        (await dispatch(
          monthwiseCommitmentAmount(selectedCurrency)
        )) as unknown as monthwiseCommitmentAmountType;
        if (!componentIsAlive) {
          return;
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, [selectedCurrency]);

  useEffect(() => {
    SetCommitAmtData(CommitmentAndContributionData);
  }, [CommitmentAndContributionData]);

  const formatCurrencyGraph = (value?: number | null, currency: 'inr' | 'usd' = 'inr'): string => {
    if (value == null || isNaN(value)) return '0';

    const units =
      currency === 'inr'
        ? [
            { value: 1e7, symbol: 'CR' },
            { value: 1e5, symbol: 'L' },
            { value: 1e3, symbol: 'K' },
          ]
        : [
            { value: 1e9, symbol: 'B' },
            { value: 1e6, symbol: 'M' },
            { value: 1e3, symbol: 'K' },
          ];

    for (const unit of units) {
      if (value >= unit.value) {
        return `${(value / unit.value).toFixed(2)}${unit.symbol}`;
      }
    }

    return value.toString();
  };
  const formatCurrencyGraphUSD = (value?: number | null): string => {
    if (!value) return '0'; // Handle null/undefined cases
    const amountInMillions = (value / 1_000_000).toFixed(2); // Always divide by 1M and format to 2 decimals
    return `${amountInMillions}`;
  };

  // const formatCurrencyGraphUSD = (value?: number | null): string => {
  //   const formats = ['K', 'M', 'B']; // Thousand, Million, Billion
  //   let amount: any = Number(value);

  //   formats.some((key, i) => {
  //     const size = Math.pow(10, (i + 1) * 3); // Correct scaling logic
  //     if (size <= amount) {
  //       amount = toExactSubstr(`${amount / size}`);
  //       if (amount >= 100 && i < formats.length - 1) {
  //         i++;
  //       } else {
  //         amount = amount.toString().length === 1 ? Number('0.0' + amount) : Number(amount); // Correct decimal logic
  //         return true;
  //       }
  //     } else {
  //       return true;
  //     }
  //   });

  //   return `${amount}${formats[formats.length - 1]}`;
  // };

  // month wise commitment and contribution amount line and bar Graph data Initialization start
  const CommAmtmonth = [] as any;

  const CommAmtmonthArr = CommitmentAndContributionData.data.map((data) => data.month);

  numToAlpMonth(CommAmtmonthArr, CommAmtmonth);

  data.lineBarData.labels = CommAmtmonth;

  const CommitmentamountBar = CommitmentAndContributionData.data.map((amt) => amt.commitmentAmount);
  const Cotrubutionamountline = CommitmentAndContributionData.data.map(
    (amt) => amt.contributionAmount
  );

  const CommitmentamountNum = [] as any;
  const CotrubutionamountNum = [] as any;

  CommitmentamountBar.map((a) => {
    CommitmentamountNum.push(a);
  });

  Cotrubutionamountline.map((a) => {
    CotrubutionamountNum.push(a);
  });

  data.lineBarData.datasets.map((total) => {
    if (total.label.includes('Commited')) {
      total.data = CommitmentamountNum;
      total.label =
        selectedCurrency === 'inr'
          ? 'Total Commited Value (in Cr)'
          : 'Total Commited Value (in Million)';
    }

    if (total.label.includes('Contribution')) {
      total.data = CotrubutionamountNum;
      total.label =
        selectedCurrency === 'inr'
          ? 'Total Contribution Value (in Cr)'
          : 'Total Contribution Value (in Million)';
    }
  });

  // Update tooltip based on currency
  const dynamicLineBarOptions = {
    ...data.lineBarOptions,
    plugins: {
      ...data.lineBarOptions.plugins,
      tooltip: {
        ...data.lineBarOptions.plugins?.tooltip,
        callbacks: {
          ...data.lineBarOptions.plugins?.tooltip?.callbacks,
          label: (item: any) => {
            return formatCurrencyGraph(item.raw, selectedCurrency);
          },
        },
      },
    },
  };

  //month wise commitment and contribution amount line and bar Graph data Initialization End

  return (
    <Grid item xs={12} sm={12} md={12} lg={7}>
      <Card
        raised={true}
        sx={{
          height: {
            lg:
              USER_ROLES.AMC_ADMIN !== role && filterData.length === 0
                ? 440
                : USER_ROLES.AMC_ADMIN !== role && filterData.length !== 0
                ? 610
                : USER_ROLES.AMC_ADMIN === role && filterData.length !== 0
                ? 440
                : USER_ROLES.AMC_ADMIN === role && filterData.length === 0
                ? 440
                : 610,
          },
          pt: USER_ROLES.AMC_ADMIN === role ? 4 : 2,
          px: USER_ROLES.AMC_ADMIN === role ? { xs: 1, sm: 3 } : { xs: 1, sm: 6 },
          pb: USER_ROLES.AMC_ADMIN === role ? 0 : 2,
          width: { lg: USER_ROLES.AMC_ADMIN === role ? 'unset' : 1160 },
        }}>
        <Typography sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 600,
              color: 'rgb(97, 209, 214)',
              pt: 1,
            }}>
            {`Year ${CommitmentAndContributionData.year}`}
          </Typography>
          <RadioGroup
            aria-label="status"
            defaultValue=""
            name="currencyType"
            sx={{ display: 'block' }}>
            {currencyType.map((type: { key: string; value: string }) => (
              <FormControlLabel
                key={type.key}
                value={type.key}
                onChange={(event: any) => setSelectedCurrency(event.target.value)}
                control={<Radio size="small" checked={type.key === selectedCurrency} />}
                label={type.value}
                title={type.value}
              />
            ))}
          </RadioGroup>
        </Typography>
        <hr />
        {!CommitmentAndContributionData.year ||
        JSON.stringify(commitAmtData) !== JSON.stringify(CommitmentAndContributionData) ? (
          <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Skeleton
                variant="rectangular"
                sx={{
                  // width: { xs: 500, sm: 600 },
                  // height: { xs: 220, sm: 270 },
                  // mt: { xs: 0, lg: 1 },
                  // mb: { xs: 0, lg: 2 },
                  // ml: { xs: 0, sm: 15, lg: 2 },
                  width: { xs: '300px', sm: USER_ROLES.AMC_ADMIN === role ? 600 : 1040 },
                  height: { xs: 220, sm: USER_ROLES.AMC_ADMIN === role ? 320 : 460 },
                  mt: { xs: 0, lg: 1 },
                  mb: { xs: 0, lg: 2 },
                  m: { xs: 0, sm: 15, lg: 2 },
                }}
              />
            </Box>
            <Skeleton
              sx={{
                width: { xs: '300px', sm: USER_ROLES.AMC_ADMIN === role ? 590 : 1040 },
                ml: { xs: 0, sm: 15, lg: 2 },
              }}
            />
          </>
        ) : (
          <>
            {filterData.length > 0 ? (
              <>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                  }}>
                  <InfoOutlinedIcon color="info" fontSize="small" />
                  <Typography
                    sx={{
                      color: 'rgba(41, 49, 57, 0.7)',
                      fontSize: 12,
                      fontWeight: 500,
                      ml: 1,
                    }}>
                    Graphical Data is shown only for completed applications .
                  </Typography>
                </Typography>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: 'rgb(97, 209, 214)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                  {`Year ${CommitmentAndContributionData.year}`}
                </Typography>
                <Typography
                  component={'div'}
                  className="canvas-container"
                  sx={{
                    '&.canvas-container': {
                      position: 'relative',
                      width: { xs: '320px', sm: 'unset' },
                      margin: 'auto',
                    },
                  }}>
                  <Chart
                    type="bar"
                    data={data.lineBarData as ChartData}
                    options={dynamicLineBarOptions as ChartOptions}
                  />
                </Typography>
              </>
            ) : (
              <>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                  }}>
                  <InfoOutlinedIcon color="info" fontSize="small" />
                  <Typography
                    sx={{
                      color: 'rgba(41, 49, 57, 0.7)',
                      fontSize: 12,
                      fontWeight: 500,
                      ml: 1,
                    }}>
                    Graphical Data is shown only for completed applications .
                  </Typography>
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    height: '100%',
                    width: '100%',
                    // backgroundColor: 'red',
                    // pt: 0,
                  }}>
                  <CardMedia
                    component="img"
                    src="/images/Nodata.png"
                    sx={{
                      height: '40%',
                      width: '40%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: 18,
                      fontWeight: 500,
                      color: 'rgb(97, 209, 214)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: USER_ROLES.AMC_ADMIN === role ? '12%' : '7%',
                    }}>
                    No Data Available
                  </Typography>
                </Box>
              </>
            )}
          </>
        )}
      </Card>
    </Grid>
  );
}
